import React, { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { makeStyles, useTheme, withStyles } from "@mui/styles";
import Avatar from "@mui/material/Avatar";
import Badge from "@mui/material/Badge";
import Typography from "@mui/material/Typography";
import VideoPlayIcon from "../../images/video-play-button.png";
import LinearProgress from "@mui/material/LinearProgress";
import Button from "@mui/material/Button";
import Link from "@mui/material/Link";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import Skeleton from '@mui/material/Skeleton';
import RouteConstants from "../../common/RouteConstants";
import APIHelper from "../../common/ApiHelper";
import APIURLConstants from "../../common/ApiURLConstants";
import JWPlayer from "../JWPlayer/JWPlayer";
import HeadShot from "../profilePhoto/HeadShot";
import CustomizedDialogs from "../../sharedComponents/dialog/jwPlayerDialog";
import HelpIcon from '@mui/icons-material/Help';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import { Tooltip } from 'react-tippy';
import { Role } from '../../helper';
import helper from "../../common/Helper";
import { userService, coachProfileService } from '../../services';
import AppConstants from "../../common/AppConstants";
import TitleWithTooltip from "../../sharedComponents/TitleWithTooltip";
import IconButton from "@mui/material/IconButton";
import GetAppIcon from "@mui/icons-material/GetApp";
import parse from 'html-react-parser';
import SendMailDialog from "../../sharedComponents/dialog/SendMailDialog";
import { useCoachProfileDialog } from "../../screens/CoachesManagement/CoachProfileDialogContext";
import SnackbarMsg from "../../sharedComponents/Snackbar/Snackbar";
import DOMPurify from 'dompurify';
import { AppDataContext } from '../../common/AppContext';
import useTelemetry from "../../utils/useTelemetry";
import ContentSummaryView from "../../sharedComponents/ContentSummaryView/ContentSummaryView";
import { useProfileContext } from "../../common/ProfileContext";
import { darkenColor } from "../../utils/appHelper";
import clsx from "clsx";
import FeedbackDialog from "../dialog/FeedbackDialog";
import { getCommonMail } from "../../services/commonMail.service";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    flex: 1,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: theme.palette.mode === 'dark' ? darkenColor(theme.palette.background.default, 25) : theme.palette.primary.dark
  },
  avatar: {
    width: theme.spacing(15),
    height: theme.spacing(15),
    margin: '0 auto 8px',
    border: '2px solid #96aacb',
  },
  PlayIcon: {
    position: 'absolute',
    right: '18%',
    bottom: '18%',
    transform: 'scale(1) translate(50%, 50%)',
    transformOrigin: '100% 100%',
    zIndex: '2',
    height: theme.spacing(6.5),
    width: theme.spacing(6.5),
    cursor: 'pointer',
  },
  divider: {
    marginTop: theme.spacing(2),
    width: "100%",
  },
  profileCompletenessTitle: {
    display: "flex",
    flexDirection: "row",
    // width: "100%",
    marginTop: theme.spacing(2),
    alignItems: "center",
  },
  profileCompletenessBar: {
    // width: "100%",
    marginTop: theme.spacing(1),
  },
  sections: {
    display: "flex",
    flexDirection: "column",
    // width: "100%",
    marginTop: theme.spacing(3),
    alignItems: "start",
  },
  linkIcon: {
    fontSize: "0.75rem",
  },
  linkText: {
    textAlign: "left",
    color: '#ffffff',
  },
  editProfile: {
    marginTop: theme.spacing(2),
    display: "flex",
    flexDirection: "column",
    '& button': {
      marginBottom: theme.spacing(1),
    },
  },
  editProfile1: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1)
  },
  skeleton: {
    width: "100%",
  },
  profileVideo: {
    width: '130px',
    height: '80px',
    cursor: 'pointer'
  },
  downloadAction: {
    marginLeft: "auto",
    color: "#000",
  },
}));

const ProfileSummary = (props) => {
  const classes = useStyles();
  const theme = useTheme();
  const navigate = useNavigate();
  const dialogCtx = useCoachProfileDialog();
  const [image, setImage] = useState(null);
  const [videoURL, setVideoURL] = useState(null);
  const [openDialog, setOpenDialog] = useState(false);
  const userRole = userService.getUserRole();
  const userName = userService.getUsername();
  const [openSendMail, setopenSendMail] = useState(false);
  const [mailId, setMailId] = useState('');
  const [showError, setShowError] = useState(false);
  const [severity, setSeverity] = useState("");
  const [message, setMessage] = useState("");
  const { trackCustomEvents } = useTelemetry();
  const {
    canISeeCoachingTree
  } = useContext(AppDataContext);
  const [showTree, setShowTree] = useState(false);
  const [primaryVideoData, setPrimaryVideoData] = useState([]);
  const [openPrimaryVideo, setOpenPrimaryVideo] = useState(false);
  const { profile } = useProfileContext();
  const [openFeedbackDialog, setOpenFeedbackDialog] = useState(false);
  const [comment, setComment] = useState('');
  const [summary, setSummary] = useState('');
  
  const [loggedInUser, setLoggedInUser] = useState('');

  const handleClick = () => {
    navigate(props.isViewMode
      ? RouteConstants.COACH_PROFILE_EDIT
      : RouteConstants.COACH_PROFILE_VIEW);
    trackCustomEvents("ClickEvent", { event: props.isViewMode ? "Edit Profile" : "View Profile" })
  };

  function donwloadPDF(event) {
    event.preventDefault();
    var xhr = coachProfileService.downloadCoachPDF();
    xhr.onload = function (e) {
      if (this.status == 200) {
        let fileName = props.fullName.firstName + "_" + props.fullName.lastName;
        fileName = fileName.replace(/([^a-z0-9 _]+)/gi, '');

        var blob = new Blob([this.response], { type: "application/pdf" });
        var link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = fileName + ".pdf";
        link.click();
      }
    };
    xhr.send();
    trackCustomEvents("ClickEvent", { event: "Download PDF" });
  }

  function handleViewCoachingTree(event) {
    const path = RouteConstants.COACHES_TREE + '/' + props?.userName;
    if (dialogCtx && dialogCtx.dialogNavigate) {
      dialogCtx.dialogNavigate(path);
    } else {
      navigate(path, {
        state: { isCoachProfile: props?.isCoachProfile }
      });
    }
    trackCustomEvents("ClickEvent", { event: "View Coaching Tree" });
  }

  const handleBackToDashboard = () => {
    if (userRole === Role.Admin) {
      if (dialogCtx && dialogCtx.close) {
        dialogCtx.close();
      } else {
        navigate(RouteConstants.COACH_MANAGEMENT);
      }
      trackCustomEvents("ClickEvent", { event: "Back To Dashboard" });
    } else if (userRole === Role.FrontOffice || userRole === Role.FrontOfficePlusCoach) {
      if (dialogCtx && dialogCtx.close) {
        dialogCtx.close();
      } else {
        navigate(RouteConstants.DASHBOARD);
      }
      trackCustomEvents("ClickEvent", { event: "Back To Dashboard" });

    } else if (userRole === Role.Coach) {
      if (dialogCtx && dialogCtx.close) {
        dialogCtx.close();
      } else {
        navigate(RouteConstants.COACH_DASHBOARD);
      }
      trackCustomEvents("ClickEvent", { event: "Back To Dashboard" });

    }
  }

  const handleClickOpen = () => {
    if (props.jwtTokenDetails && props.jwtTokenDetails.JWPlayerKey && props.jwtTokenDetails.JWPlayerSource) {
      setOpenDialog(true);
    }
  }
  useEffect(() => {
    if (props.userName) {
      let profileurl = APIURLConstants.GET_PROFILE_VIDEO + props.userName;
      setVideoURL(profileurl);

      if (props.profileVideos) {
        // Find the primary video object
        let primaryVideoObject = props.profileVideos.find(video => video.isPrimaryVideo);
        try {
          if (primaryVideoObject) {
            primaryVideoObject = JSON.parse(JSON.stringify(primaryVideoObject));
          }
        } catch (error) {

        }
        if (primaryVideoObject && primaryVideoObject.videoURL) {
          let service = userService.getProfileVideosSignedUrl;
          service(primaryVideoObject.videoURL)
            .then(videoUrl => {

              primaryVideoObject.videoURL = videoUrl;

              // Set primary video object in state
              setPrimaryVideoData(primaryVideoObject);
            })
            .catch(error => {
              // Handle any errors
              console.error('Error fetching video URL:', error);
            });
        }
      }
    }
  }, [props.userName, props.profileVideos]);

  useEffect(() => {
    function getCurrentUser() {
      let currentUser = JSON.parse(localStorage.getItem('currentUser'))
      console.log('currentUser', currentUser)
      let fullName = currentUser?.firstName + " " + currentUser?.lastName;
      console.log('fullName', fullName)
      setLoggedInUser(fullName)
    }
    getCurrentUser()
  }, [])

  const [open, setOpen] = React.useState(false);
  const handleTooltipClose = () => {
    setOpen(false);
  };
  const handleTooltipOpen = () => {
    setOpen(true);
  };
  const formattedDate = (date) => {
    return helper.IfDateIsNULL(date) ? '' : helper.FormatDateToLocalTimeZone(date);
  }
  const togalSendMAilDialog = () => {
    setopenSendMail(!openSendMail);
    trackCustomEvents("ClickEvent", { event: "Share Profile" });
  }

  const SendMail = () => {
    let regex = /^([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5})$/;
    let validEmail = regex.test(mailId)
    if (!validEmail) {
      setSeverity("error");
      setMessage("Enter valid email")
      setShowError(true);
      return;
    }
    else {
      coachProfileService.sendProfile(props.userName, mailId)
        .then(data => {
          setMailId("");
          setopenSendMail(!openSendMail);
          setSeverity("success");
          setMessage("Email Sent")
          setShowError(true);
        })
    }
  }

  const handleClose = () => {
    setShowError(false);
    setSeverity("")
    setMessage("");
  }

  const GameVideoBadge = withStyles((theme) => ({

  }))(Badge);

  const handleHeadShotClick = () => {

    if (props.jwtTokenDetails && props.jwtTokenDetails.JWPlayerKey && props.jwtTokenDetails.JWPlayerSource) {

      setOpenPrimaryVideo(true);
    }
    trackCustomEvents("ClickEvent", { event: "Headshot Video" })
  };

  const toggleFeedbackDialog = () => {
    setOpenFeedbackDialog(!openFeedbackDialog)
  }

  function formatSummary(text) {
    const items = text
      ?.split('\n')
      .map(line => `<p>${line}</p>`)
      .join('');
    return `<div>${items}</div>`;
  }

  //const summaryText = convertDashToList(summary);

  let receiver = ["mhaque@nba.com", "Saurabh.nandan@thedigitalgroup.com", "mazhar.haque@thedigitalgroup.com", "sagar.jadhav@thedigitalgroup.com", "damin@nba.com"]

  const onSubmitFeedback = async () => {
    let title = `CoachesDB - ${loggedInUser} has left a feedback.`

    let summaryText = formatSummary(summary);

    let body = `<html>
        <head>
            <style>
            body {
                margin: 0;
                padding: 0;
                color: black;
                font-family: ActionNBAApp-Medium;
                background-color: transparent;
            }
            </style>
        </head>
        <p>${loggedInUser} has left the feedback on the following summary:</p>
        <p></p>
        <p>Summary:</p>
        ${summaryText}
        <p></p>
        <p>Feedback (optional): ${comment ? comment : "N/A"}</p>
        </html>`;
    
    await getCommonMail(receiver, title, body);
    setOpenFeedbackDialog(!openFeedbackDialog)
    setComment('')
    //getSnackBar(res.data.code)
  }

  const onGetSummaryResponse = (summary) => {
    setSummary(summary)
  }

  const onShowMorePress = (expanded) => {
    //console.log('onShowMorePress called',expanded)
    trackCustomEvents('ClickEvent', { event: expanded ? "Profile Highlights show more clicked" : "Profile Highlights show less clicked"});
  }

  //console.log('user',JSON.parse(localStorage.getItem('currentUser')))

  return (
    <div className={classes.root}>
      {/* {image && */}
      {/* <Avatar alt="profile photo" src={image} className={classes.avatar} /> */}

      <div className="headShot">
        <div >

          <GameVideoBadge>
            {primaryVideoData && primaryVideoData.videoURL && (<Avatar variant="square" className={classes.PlayIcon} src={VideoPlayIcon} onClick={handleHeadShotClick}></Avatar>)}
            <HeadShot
              userName={props.userName}
              coachName={`${props.fullName && props.fullName.firstName ? props.fullName.firstName : ''} ${props.fullName && props.fullName.lastName ? props.fullName.lastName : ''}`} className={classes.avatar} profilePhoto={props.profilePhoto} />
          </GameVideoBadge>

        </div>


        <Typography
          variant="h6"
          style={{ textAlign: "center", color: '#ffffff', }}
        >{`${props.fullName && props.fullName.firstName ? props.fullName.firstName : ''} ${props.fullName && props.fullName.lastName ? props.fullName.lastName : ''} ${props.fullName && props.fullName.suffix ? props.fullName.suffix : ''}`}</Typography>
        <Typography variant="caption"></Typography>
      </div>
      {/* <Typography variant="caption">{email ? email : ''}</Typography> */}
      {/* <Divider className={classes.divider}></Divider> */}
      <div className="profile-summary" style={{ backgroundColor: theme.palette.mode === 'dark' ? theme.palette.background.paper : theme.palette.primary.main }}>
        {(userRole == Role.FrontOfficePlusCoach || userRole == Role.Coach) &&
          props.profileCompleteness && <>
            <div className={classes.profileCompletenessTitle}>
              <Typography variant="subtitle2">
                Profile Completeness
              </Typography>
              <Typography
                variant="body2"
                style={{ marginLeft: "auto" }}
              >
                {props.profileCompleteness}% &nbsp;
              </Typography>
              {props.remainingSection && props.remainingSection.length > 0 &&
                <ClickAwayListener onClickAway={handleTooltipClose}>
                  <Tooltip
                    PopperProps={{
                      disablePortal: true,
                    }}
                    onClose={handleTooltipClose}
                    open={open}
                    disableFocusListener
                    disableHoverListener
                    disableTouchListener
                    title={`Please complete following section(s) to complete your profile: ${props.remainingSection.join(", ")}`}>
                    <HelpIcon onClick={handleTooltipOpen} fontSize="small" style={{ width: '20px', heigh: '20px' }} />
                  </Tooltip>
                </ClickAwayListener>}

            </div>

            <div className={classes.profileCompletenessBar}>
              <LinearProgress
                variant="determinate"
                value={props.profileCompleteness}
                sx={{
                  backgroundColor: '#898989',
                  '& .MuiLinearProgress-bar': {
                    backgroundColor: '#d9d9d9',
                  },
                }}
              ></LinearProgress>
            </div>
          </>
        }

        {props.isViewMode && (
          <>
            <div className={classes.sections}>
              <Typography variant="subtitle2">About Me</Typography>
              {props.roleAndCoachingPhilosophy && props.roleAndCoachingPhilosophy.description ? (
                <Typography variant="body2" >
                  {parse(DOMPurify.sanitize(props.roleAndCoachingPhilosophy.description))}
                  {/* {(props.roleAndCoachingPhilosophy.description)} */}
                </Typography>
              ) : (
                <div className={classes.skeleton}>
                  <Skeleton />
                  <Skeleton />
                  <Skeleton width="60%" />
                </div>
              )}
            </div>
            {/* {props.profileVideo && props.profileVideo.videoURL &&
              <div className={classes.sections}>
                <Typography variant="subtitle2">Uploaded Video</Typography>
             
                <img src={playIcon} className={classes.profileVideo} onClick={handleClickOpen} />
              </div>
            } */}
            {/* <div className={classes.sections}> */}
            {/* <TitleWithTooltip
                variant="subtitle2"
                title="Video Links"
                tooltipTitle="Video_Link_Tooltip"               
                class={classes.question}
              /> */}
            {/* <Typography variant="subtitle2">Video Links</Typography>
              {props.coachingVideos && props.coachingVideos.externalLinks && props.coachingVideos.externalLinks.length > 0 &&
                props.coachingVideos.externalLinks.map((link, index) => {
                  if (link && link.label && link.label != '') {
                    return (
                      <Link
                        key={index}
                        variant="body2"
                        className={classes.linkText}
                        href={link.url}
                        target="blank"
                      >
                        {link.label} &nbsp;
                        <OpenInNewIcon className={classes.linkIcon} />
                      </Link>
                    )
                  }
                  else {
                    return null;
                  }
                })
              } */}
            {/* </div> */}

            {
              (profile?.profileSummary || props.profile?.profileSummary) && <>
                <div className={classes.sections}>
                  <Typography variant="subtitle2">Career Highlights</Typography>
                  <ContentSummaryView
                    externalSummary={profile?.profileSummary || props.profile?.profileSummary}
                    onSummaryResponse={(summary) => onGetSummaryResponse(summary)}
                    feedback={false}
                    summaryStyle={{ fontSize: 11, whiteSpace: 'pre-line' }}
                    showMoreButton={true}
                    showMore="Show more"
                    showLess="Show less"
                    showMoreButtonOnPress={(expanded) => onShowMorePress(expanded)}
                    showMoreStyle={{ fontSize: 12, fontWeight: '700' }}
                    disclaimer={true}
                    disclaimerStyle={{ fontSize: 12 }}
                    dividerStyle={{ height: 0.5 }}
                    disclaimerText="[AI Generated] See a mistake? Let us know."
                    clickableText="Let us know"
                    onPress={() => toggleFeedbackDialog()}
                  />
                </div>
              </>
            }

            <div className={classes.sections}>
              <Typography variant="subtitle2">Articles/Media Links</Typography>
              {props.mediaAndArticle && props.mediaAndArticle.externalLinks && props.mediaAndArticle.externalLinks.length > 0 &&
                props.mediaAndArticle.externalLinks.map((link, index) => {
                  if (link && link.label && link.label != '') {
                    return (
                      <Link
                        key={index}
                        variant="body2"
                        className={classes.linkText}
                        href={link.url}
                        target="blank"
                      >
                        {link.label} &nbsp;
                        <OpenInNewIcon className={classes.linkIcon} />
                      </Link>
                    )
                  }
                  else {
                    return null;
                  }
                })
              }
            </div>
            {props && props.profileViewCount > 0 &&
              <div className={classes.sections}>
                <Typography variant="subtitle2">Profile Views In The Last 7 Days</Typography>
                <Typography variant="body2">
                  {props ? props.profileViewCount + " Times" : '0' + " Times"}</Typography>
              </div>
            }
            <div className={classes.sections}>
              <Typography variant="subtitle2">Last Updated On </Typography>
              <Typography variant="body2">
                {props ? formattedDate(props.lastModifiedAt) : ''}</Typography>
            </div>
            {/* <Divider className={classes.divider}></Divider> */}
          </>
        )}
      </div>
      {(userRole == Role.FrontOfficePlusCoach || userRole == Role.Coach) &&
        (props.isCoachProfile || props.userName === userName) && (
          <div className={classes.editProfile}>
            <Button
              variant="contained"
              color="secondary"
              size="small"
              onClick={handleClick}
            >
              {props.isViewMode ? "Edit Profile" : "View Profile"}
            </Button>
            {props.isViewMode ?
              <><Button
                variant="contained"
                color="secondary"
                size="small"
                onClick={donwloadPDF}
              >
                Download Profile
              </Button>
                <Button
                  variant="contained"
                  color="secondary"
                  size="small"
                  onClick={togalSendMAilDialog}
                >
                  Share Profile
                </Button>
                {/* <Tooltip title="SendMail" style={{ cursor: "pointer" }}>
                  <ShareIcon onClick={togalSendMAilDialog} color="primary" />
                </Tooltip> */}
              </> : ""}
          </div>
        )
      }

      {props.isViewMode && (userRole === Role.Admin || ((userRole === Role.FrontOffice || userRole === Role.FrontOfficePlusCoach) && canISeeCoachingTree != undefined && canISeeCoachingTree == 'true') || (userRole === Role.Coach && canISeeCoachingTree != undefined && canISeeCoachingTree === 'true')) &&
        <div className={classes.editProfile1}>
          {/* {props.isViewMode ? */}
          <Button
            variant="contained"
            color="secondary"
            size="small"
            onClick={handleViewCoachingTree}
          >
            View Coaching Tree
          </Button>
        </div>
      }
      {/* : ""} */}

      {((props.showBackButton || props.isViewMode) && (userRole === Role.Admin || userRole === Role.FrontOffice || (userRole === Role.Coach && !props.isCoachProfile && canISeeCoachingTree != undefined && canISeeCoachingTree === 'true') || (userRole === Role.FrontOfficePlusCoach))) &&
        <div>
          <Button
            variant="contained"
            color="secondary"
            size="small"
            onClick={handleBackToDashboard}
            style={{ marginBottom: "10px" }}
          >
            Back To Dashboard
          </Button>
        </div>
      }
      {props.jwtTokenDetails && props.jwtTokenDetails.JWPlayerKey && props.profileVideo && props.profileVideo.videoURL &&
        <CustomizedDialogs open={openDialog} title="View Video"
          data={{
            jwtTokenDetails: props.jwtTokenDetails,
            videoURL: videoURL,
            userName: props.userName,
            title: AppConstants.VIDEO_PLAYER.PROFILE_TITLE
          }} onClose={() => setOpenDialog(false)} />
      }
      {props.jwtTokenDetails && props.jwtTokenDetails.JWPlayerKey && primaryVideoData && primaryVideoData.videoURL &&
        <CustomizedDialogs open={openPrimaryVideo} title="View Video"
          data={{
            jwtTokenDetails: props.jwtTokenDetails,
            videoURL: primaryVideoData.videoURL,
            userName: props.userName,
            playExternalVideo: true,
            title: primaryVideoData.title
          }} onClose={() => setOpenPrimaryVideo(false)} />
      }
      <SendMailDialog open={openSendMail}
        onClose={togalSendMAilDialog}
        onSendMail={SendMail}
        mailId={mailId}
        setMailId={setMailId}
      />

      <FeedbackDialog open={openFeedbackDialog}
        onClose={toggleFeedbackDialog}
        onSubmitFeedback={onSubmitFeedback}
        comment={comment}
        setComment={setComment}
      />
      <SnackbarMsg showError={showError} onClose={handleClose} severity={severity} msg={message} />

    </div>
  );
};

export default ProfileSummary;
